import initVoting from '../util/voting';

export default {
  init() {
    window.chosenAgencies = [];
    $('[data-toggle="tooltip"]').tooltip()

    $('.js-jury-more').on('click', function() {
      $(this)
        .closest('.jury-card')
        .addClass('jury-card--active');
    });

    $('.js-jury-less').on('click', function() {
      $(this)
        .closest('.jury-card')
        .removeClass('jury-card--active');
    });

    $('.js-send-request').on('click', function() {
      $('#sendRequest').modal({});
    });

    $('.js-send-agencies').on('click', function() {
      if(window.chosenAgencies.length > 0) {
        $('#sendAgencies').modal({});
      }
    });

    $('.hamburger').on('click', function() {
      if(!$(this).hasClass('is-active')) {
        $(this).addClass('is-active');
        $('.mobile-nav').slideDown();
      } else {
        $(this).removeClass('is-active');
        $('.mobile-nav').slideUp();
      }
    });

    $('.dropdown-menu').on('click.bs.dropdown', function (e) { e.stopPropagation(); });

    $('.js-choice-box').on('change', function() {
      const choices = [];

        if ($(this).data('choice') == 'all') {
            $('.js-choice-box').not(this).prop('checked', false);
        } else {
            $('.js-choices-dropdown .js-choice-box').first().prop('checked', false);
        }

        $('.js-choices-dropdown .js-choice-box').each(function() {
        if($(this).prop('checked')) {
          choices.push($(this).data('choice'));
        }
      });
      $('.r-table').find('.r-table__cell--segment').each(function() {
        const $this = $(this);
        if( choices.indexOf('all') === -1) {
          const segment =$this.data('segment');
          const isIn = choices.indexOf(segment) === -1;
          if(isIn) {
            $this.closest('.r-table__row').slideUp();
          } else {
            $this.closest('.r-table__row').slideDown();
          }
        } else {
          $this.closest('.r-table__row').fadeIn();
        }
      })
    })

    initVoting();

    $('.js-more-agencies').on('click', function () {
      $('.js-agencies-others').slideToggle();
      $('.js-more-agencies').css('display', 'none');
      $('.js-less-voting-agencies').css('display', 'block');
    });

    $('.js-less-voting-agencies').on('click', function () {
      $('.js-agencies-others').slideToggle();
      $('.js-less-voting-agencies').css('display', 'none');
      $('.js-more-agencies').css('display', 'block');
    });

    $('.slider').slick({
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
    });

    $('.slider-2').slick({
        prevArrow: $('.prev-2'),
        nextArrow: $('.next-2'),
    });

    $('#myMenu').find('a').on('click', function(){
        $('#mySearch').val($(this).text());
        $('#myMenu').hide();
    });

    $(function() {
          var menuhe = $('.main-header').height();
          var menu;
          if ($(window).width()< 768) {
              console.log($(window).width());
              if($('.r-table__head').length) {
                  menu = menuhe+90;
              }else {
                  menu = menuhe+5;
              }
          }
          else {
              if($('.r-table__head').length) {
                  menu = menuhe+125;
              }else {
                  menu = menuhe+5;
              }
          }

          $( document ).ready(function() {
            const target = location.hash;
            if (target.length) {
              let input = document.getElementById('mySearch');
              input.value = target.slice(1);
              window.search();
            }
          });

          $('area[href*=#],a[href*=#]:not([href=#]):not([href^=\'#tab\']):not([href^=\'#quicktab\']):not([href^=\'#pane\']):not([href *= \'#inline\'])').click(function() {
              if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                  var target = $(this.hash);
                  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                  if (target.length) {
                      $('html,body').animate({
                          scrollTop: target.offset().top - menu,
                      },1500);
                      return false;
                  }
              }
          });
      });

    window.search = function () {
        let input, filter, ul, li, a, i, filterRus, filterEng, choices = [];
        input = document.getElementById('mySearch');
        filter = input.value.toUpperCase();
        ul = document.getElementById('myMenu');
        li = ul.getElementsByTagName('li');
        $('#myMenu').show();
        $('.js-choices-dropdown .js-choice-box').each(function() {
            if ($(this).prop('checked')) {
                choices.push($(this).data('choice'));
            }
        });


        if (input.value.length >= 1) {
            filterRus = filterToRus(filter);
            filterEng = filterToEng(filter);
            $('.js-agencies-others').css('display','block');
            $('.js-more-agencies').css('display', 'none');
            $('.js-voting-agencies-others').css('display','block');
            $('.js-less-voting-agencies').css('display', 'block');

            for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName('a')[0];
            if( choices.indexOf('all') === -1 && choices.length !== 0) {
                const segment = $(li[i]).data('segment');
                const isIn = choices.indexOf(segment) === -1;
                if (a.innerHTML.toUpperCase().indexOf(filter) > -1 && !isIn) {
                    li[i].style.display = 'block';
                } else if (a.innerHTML.toUpperCase().indexOf(filterEng) > -1 && !isIn) {
                    li[i].style.display = 'block';
                } else if (a.innerHTML.toUpperCase().indexOf(filterRus) > -1 && !isIn) {
                    li[i].style.display = 'block';
                } else {
                    li[i].style.display = 'none';
                }
            } else {
                if (a.innerHTML.toUpperCase().indexOf(filter) > -1) {
                    li[i].style.display = 'block';
                } else if (a.innerHTML.toUpperCase().indexOf(filterEng) > -1) {
                    li[i].style.display = 'block';
                } else if (a.innerHTML.toUpperCase().indexOf(filterRus) > -1) {
                    li[i].style.display = 'block';
                } else {
                    li[i].style.display = 'none';
                }
            }
        }
        } else {
            $('.js-more-agencies').css('display', 'block');
            $('.js-agencies-others').css('display','none');
            $('.js-voting-agencies-others').css('display','none');
            $('.js-less-voting-agencies').css('display', 'none');
            for (i = 0; i < li.length; i++) {
                li[i].style.display = 'none';
            }
        }

    }
      function filterToRus( str ) {
          var replacer = {
              'q':'й', 'w':'ц', 'e':'у', 'r':'к', 't':'е', 'y':'н', 'u':'г',
              'i':'ш', 'o':'щ', 'p':'з', '[':'х', ']':'ъ', 'a':'ф', 's':'ы',
              'd':'в', 'f':'а', 'g':'п', 'h':'р', 'j':'о', 'k':'л', 'l':'д',
              ';':'ж', '\'':'э', 'z':'я', 'x':'ч', 'c':'с', 'v':'м', 'b':'и',
              'n':'т', 'm':'ь', ',':'б', '.':'ю', '/':'.',
          };

          var string =  str.replace(/[A-z/,.;'\][]/g, function ( x ){
              return x == x.toLowerCase() ? replacer[ x ] : replacer[ x.toLowerCase() ].toUpperCase();
          });
          return string
      }
      function filterToEng( str ) {
          var replacer = {
              'й': 'q', 'ц': 'w', 'у': 'e', 'к': 'r', 'е': 't', 'н': 'y', 'г': 'u',
              'ш': 'i', 'щ': 'o', 'з': 'p', 'х': '[', 'ъ': ']', 'ф': 'a', 'ы': 's',
              'в': 'd', 'а': 'f', 'п': 'g', 'р': 'h', 'о': 'j', 'л': 'k', 'д': 'l',
              'ж': ';', 'э': '\'', 'я': 'z', 'ч': 'x', 'с': 'c', 'м': 'v', 'и': 'b',
              'т': 'n', 'ь': 'm', 'б': ',', 'ю': '.', '.': '/',
          };

          var string = str.replace(/[А-яЁё]/g, function (x) {
              return x == x.toLowerCase() ? replacer[ x ] : replacer[ x.toLowerCase() ].toUpperCase();
          });
          return string;
      }

},
  finalize() {
    // Для floating label у текстовых инпутов, чтобы оставалась над инпутом если в поле что-то записано
    $('.rt-form__control input').on('change', function(e) {
      $(this).attr('data-value', e.target.value);
    });

  },

};



// WEBPACK FOOTER //
// ./scripts/routes/common.js